// extracted by mini-css-extract-plugin
export default {"wrapper":"submit-success_wrapper__s1k4P","image":"submit-success_image__-fr73"};